import AllCards from './AllCards';

export default AllCards;
